import { Epic, combineEpics } from 'redux-observable';
import { isOfType } from 'typesafe-actions';
import { filter, mergeMap, map, ignoreElements } from 'rxjs/operators';
import { of, EMPTY } from 'rxjs';
import ReactGA from 'react-ga';

import { IRootAction, IRootState } from 'reducers';

const watchLocation: Epic<IRootAction, any, IRootState> = (action$, state$) =>
  action$.pipe(
    filter(isOfType('@@router/LOCATION_CHANGE')),
    map<any, any>(({ payload }) => {
      ReactGA.pageview(payload.location.pathname);
    }),
    ignoreElements(),
);

export default combineEpics(
  watchLocation,
);
